import BasicCard from './basic-card';

export {
  BasicCard,
}



// WEBPACK FOOTER //
// src/common/widgets/index.js